import React from 'react';

// Updated Product Data with variants and removed "Order Based Foods"
const rawProductsData = [
  // Traditional Foods
  {
    id: 'tf1',
    name: 'Sakinalu',
    teluguName: 'సకినాలు',
    description: 'Crispy, spiral-shaped traditional snack made from rice flour and sesame seeds, a festive delight.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753897576/sakinalu_xvnccr.jpg',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 279.00 },
    ],
  },
  {
    id: 'tf2',
    name: 'Gyaralu',
    teluguName: 'గ్యారలు',
    description: 'Deep-fried, savory rice flour fritters, a popular and crunchy Andhra snack, perfect with tea.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753897580/gyarlu_imydbx.jpg',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 279.00 },
    ],
  },
  {
    id: 'tf3',
    name: 'Ariselu',
    teluguName: 'అరిసెలు',
    description: 'Sweet rice flour cakes, deep-fried and coated with jaggery syrup, a traditional festive delicacy.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753898150/ARI_f4okfn.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 179.00 },
      { size: '1KG', price: 299.00 },
    ],
  },
  {
    id: 'tf4',
    name: 'Murukulu',
    teluguName: 'మురుకులు',
    description: 'Crunchy, savory spirals made from rice flour and urad dal, seasoned with spices, perfect with tea.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753897992/MURK_d2iehe.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 269.00 },
    ],
  },
  {
    id: 'tf5',
    name: 'Bondhi Laddu',
    teluguName: 'బొంది లడ్డు',
    description: 'Sweet spherical desserts made from tiny fried gram flour pearls, soaked in sugar syrup, a delightful treat.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753898501/LD_-2_hr07aa.png',
    variants: [
      { size: '250g', price: 109.00 },
      { size: '500g', price: 189.00 },
      { size: '1KG', price: 299.00 },
    ],
  },
  {
    id: 'tf6',
    name: 'Bondhi',
    teluguName: 'బొంది',
    description: 'Savory fried gram flour pearls, often used in mixtures or as a standalone snack, light and crispy.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753899025/BONDI_aa33vb.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 269.00 },
    ],
  },
  {
    id: 'tf7',
    name: 'Star Murkulu',
    teluguName: 'స్టార్ మురుకులు',
    description: 'Premium star-shaped murukulu with a perfect blend of spices, crispy and flavorful traditional snack.',
    category: 'Traditional Foods',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1200,h_800/v1754585740/star_nsm32m.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 269.00 },
    ],
  },

  // Traditional Snacks
  {
    id: 'ts1',
    name: 'Karam Gavvalu',
    teluguName: 'కారం గవ్వలు',
    description: 'Spicy, crispy, shell-shaped snacks made from flour, deep-fried to a perfect crunch.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753899089/KR_GAVVALU_s9lojx.png',
    variants: [
      { size: '250g', price: 89.00 },
      { size: '500g', price: 139.00 },
      { size: '1KG', price: 249.00 },
    ],
  },
  {
    id: 'ts2',
    name: 'Sweet Gavvalu',
    teluguName: 'తీపి గవ్వలు',
    description: 'Sweet, shell-shaped snacks, deep-fried and coated in a delicate jaggery syrup.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753899424/SUGAR_GAVVALU_vbpbcy.png',
    variants: [
      { size: '250g', price: 89.00 },
      { size: '500g', price: 139.00 },
      { size: '1KG', price: 239.00 },
    ],
  },
  {
    id: 'ts3',
    name: 'Malida Muddalu',
    teluguName: 'మలిద ముద్దలు',
    description: 'Sweet balls made from wheat flour, Sugar, and ghee, a healthy and tasty traditional treat.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753899727/MALIDA_aiv32w.png',
    variants: [
      { size: '250g', price: 89.00 },
      { size: '500g', price: 139.00 },
      { size: '1KG', price: 239.00 },
    ],
  },
  {
    id: 'ts4',
    name: 'Sesame Laddu',
    teluguName: 'నువ్వుల లడ్డు',
    description: 'Nutritious and sweet laddus made from roasted sesame seeds and jaggery, packed with energy.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753900054/NUVV_mbgxbg.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 169.00 },
      { size: '1KG', price: 280.00 },
    ],
  },
  {
    id: 'ts5',
    name: 'Ravva Laddu',
    teluguName: 'రవ్వ లడ్డు',
    description: 'Sweet semolina balls flavored with cardamom and ghee, a delightful and melt-in-your-mouth Indian dessert.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753900918/RAVVA_cnelrr.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 249.00 },
    ],
  },
  {
    id: 'ts6',
    name: 'Pyalala Laddu',
    teluguName: 'ప్యాలాల లడ్డు',
    description: 'Sweet and crunchy laddus made from puffed rice and jaggery, a simple yet delicious snack.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753901123/PYA_hrjips.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 159.00 },
      { size: '1KG', price: 229.00 },
    ],
  },
   {
    id: 'ts7',
    name: 'Motichur Laddu',
    teluguName: 'మోతీచూర్ లడ్డు',
    description: 'Motichur laddu is a traditional North Indian sweet made from tiny fried boondi pearls (deep-fried gram flour batter) mixed with a sugar syrup and shaped into soft, round balls.',
    category: 'Traditional Snacks',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1757523711/moti_fu1ymh.png',
    isNewLaunch: true,
    variants: [
      { size: '250g', price: 149.00 },
      { size: '500g', price: 289.00 },
      { size: '1KG', price: 499.00 },
    ],
  },

  // Other Items (fixed sizes)
  {
    id: 'oi1',
    name: 'Sarvapindi',
    teluguName: 'సర్వపింది',
    description: 'Savory and crispy rice flour flatbread, a popular Telangana breakfast, a healthy and filling option.',
    category: 'Other Items',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753902881/SARVA_ckxjow.png',
    minQuantity: 5,
    variants: [
      { size: 'Small', price: 39.00 },
      { size: 'Large', price: 69.00 },
    ],
  },
  {
    id: 'oi2',
    name: 'Baksalu',
    teluguName: 'బక్సలు',
    description: 'Sweet flatbreads, also known as Puran Poli, filled with a sweet lentil mixture, a delightful dessert.',
    category: 'Other Items',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1753902878/BAK_tky25z.png',
    minQuantity: 5,
    variants: [
      { size: 'Small', price: 29.00 },
      { size: 'Large', price: 49.00 },
    ],
  },
  {
    id: 'oi3',
    name: 'Gulab Jamun',
    teluguName: 'గులాబ్ జామున్',
    description: 'Soft and spongy milk-based dumplings soaked in aromatic sugar syrup, a beloved Indian dessert.',
    category: 'Other Items',
    image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1200,h_800/v1754162801/Gulab_lexsqf.png',
    variants: [
      { size: '250g', price: 99.00 },
      { size: '500g', price: 169.00 },
      { size: '1KG', price: 269.00 },
    ],
  },
];

// Filter out "Order Based Foods"
const productsData = rawProductsData.filter(
  (product) => product.category !== 'Order Based Foods'
);

// Cart Context - Simple implementation using React Context
const CartContext = React.createContext();

// Cart Provider Component
export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = React.useState([]);

  const addToCart = (product, variant, quantity = 1) => {
    const cartItem = {
      id: `${product.id}-${variant.size}`,
      productId: product.id,
      name: product.name,
      teluguName: product.teluguName,
      image: product.image,
      size: variant.size,
      price: variant.price,
      quantity: quantity,
      minQuantity: product.minQuantity
    };

    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.id === cartItem.id);
      if (existingItem) {
        return prevItems.map(item =>
          item.id === cartItem.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prevItems, cartItem];
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems(prevItems => prevItems.filter(item => item.id !== itemId));
  };

  const updateQuantity = (itemId, newQuantity, minQuantity = 1) => {
    if (newQuantity < minQuantity) {
      return;
    }
    if (newQuantity <= 0) {
      removeFromCart(itemId);
      return;
    }
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.id === itemId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getCartItemCount = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <CartContext.Provider value={{
      cartItems,
      addToCart,
      removeFromCart,
      updateQuantity,
      getCartTotal,
      getCartItemCount
    }}>
      {children}
    </CartContext.Provider>
  );
};

// Hook to use cart context
const useCart = () => {
  const context = React.useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

// Product Card Component
const ProductCard = ({ product }) => {
  const [selectedVariantIndex, setSelectedVariantIndex] = React.useState(0);
  const [isAdding, setIsAdding] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const { addToCart, cartItems, updateQuantity } = useCart(); 
  const currentVariant = product.variants[selectedVariantIndex];
  
  // Get quantity of current variant in cart
  const cartItemId = `${product.id}-${currentVariant.size}`;
  const cartItem = cartItems.find(item => item.id === cartItemId);
  const quantityInCart = cartItem ? cartItem.quantity : 0;
  const minQuantity = product.minQuantity || 1;

  const handleAddToCart = async (e) => {
    e.stopPropagation();
    setIsAdding(true);
    
    // Add to cart with minimum quantity
    addToCart(product, currentVariant, minQuantity);
    
    // Show feedback for a moment
    setTimeout(() => {
      setIsAdding(false);
    }, 1000);
  };

  return (
    <div className="rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full relative bg-white border border-gray-100">
      {/* Special Badges */}
      <div className="absolute top-3 left-3 z-10 flex flex-col gap-2">
        {product.isLaunchingSoon && (
          <div className="px-3 py-1 text-white text-xs font-bold rounded-full shadow-lg flex items-center gap-1" style={{backgroundColor: '#D62828'}}>
            <span>🚀</span>
            <span>Launching Soon</span>
          </div>
        )}
        {product.isNewLaunch && (
          <div className="px-3 py-1 text-white text-xs font-bold rounded-full shadow-lg flex items-center gap-1" style={{backgroundColor: '#185E20'}}>
            <span className="animate-bounce">✨</span>
            <span>New Launch</span>
          </div>
        )}
      </div>

      {/* Cart Indicator Badge */}
      {quantityInCart > 0 && (
        <div 
          className="absolute top-3 right-3 z-10 min-w-6 h-6 px-1 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-lg"
          style={{backgroundColor: '#D62828'}}
        >
          {quantityInCart}
        </div>
      )}
      
      {/* Image container with consistent 4:3 aspect ratio for all devices */}
      <div
        className="relative w-full bg-gray-50 overflow-hidden"
        style={{ 
          aspectRatio: '4/3', 
          minHeight: '200px',
          maxHeight: '320px'
        }}
      >
        {/* Loading placeholder */}
        {!imageLoaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
            <div className="animate-pulse bg-gray-200 w-16 h-16 rounded-lg"></div>
          </div>
        )}
        
        <img
          src={product.image}
          alt={product.name}
          className={`absolute inset-0 w-full h-full object-cover transition-all duration-300 hover:scale-105 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ 
            backgroundColor: '#FFD54F',
            objectFit: 'cover',
            objectPosition: 'center'
          }}
          onLoad={() => setImageLoaded(true)}
          onError={(e) => { 
            e.target.onerror = null; 
            e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjQwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNGM0Y0RjYiLz48cGF0aCBkPSJNMTUwIDEyNUwyNTAgMTc1SDE1MFYxMjVaIiBmaWxsPSIjOUI5OUI5Ii8+PHBhdGggZD0iTTIwMCAxMDBMMjUwIDEyNUgyMDBWMTAwWiIgZmlsbD0iIzlCOUI5OSIvPjx0ZXh0IHg9IjIwMCIgeT0iMjEwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjNjU2NTY1IiBmb250LWZhbWlseT0ic2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCI+SW1hZ2UgTm90IEZvdW5kPC90ZXh0Pjwvc3ZnPg==";
            setImageLoaded(true);
          }}
        />
      </div>

      {/* Product details with improved spacing */}
      <div className="p-5 flex-grow flex flex-col">
        {/* Product names with attractive color scheme */}
        <div className="text-center mb-4">
          <h3 
            className="text-lg font-bold mb-2 leading-tight"
            style={{color: '#D62828'}}
          >
            {product.name}
          </h3>
          <p 
            className="text-lg font-semibold mb-3"
            style={{
              fontFamily: 'NTR, sans-serif',
              color: '#185E20'
            }}
          >
            {product.teluguName}
          </p>
          
          {/* Combo Items Display */}
          {product.comboItems && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-2">
              <div className="text-sm font-semibold mb-2" style={{color: '#D62828'}}>
                 Includes:
              </div>
              <div className="space-y-1">
                {product.comboItems.map((item, index) => (
                  <div key={index} className="text-sm flex items-center justify-center gap-2" style={{color: '#185E20'}}>
                    <span className="w-1.5 h-1.5 rounded-full" style={{backgroundColor: '#D62828'}}></span>
                    <span className="font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* Minimum Quantity Notice */}
          {minQuantity > 1 && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-2">
              <div className="text-sm font-medium" style={{color: '#185E20'}}>
                Minimum order: {minQuantity} pieces
              </div>
            </div>
          )}
        </div>

        {/* Variant selection with improved mobile styling */}
        {product.variants.length > 1 && !product.isLaunchingSoon && (
          <div className="mb-5">
            <div className="flex flex-wrap gap-2 justify-center">
              {product.variants.map((variant, index) => (
                <button
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedVariantIndex(index);
                  }}
                  className={`py-2 px-4 rounded-full text-sm font-medium transition-all duration-200 border-2 min-w-16 ${
                    selectedVariantIndex === index
                      ? 'text-white border-gray-600 shadow-md scale-105' 
                      : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400 hover:bg-gray-50'
                  }`}
                  style={selectedVariantIndex === index ? {backgroundColor: '#185E20'} : {}}
                >
                  {variant.size}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Price and add to cart section with improved styling */}
        <div className="mt-auto border-t border-gray-100 pt-4">
          <div className="flex items-center justify-between gap-3">
            {product.isLaunchingSoon ? (
              <div className="w-full text-center">
                <span className="text-lg font-bold" style={{color: '#D62828'}}>
                  Launching Soon
                </span>
              </div>
            ) : (
              <>
                <div className="text-left">
                  <span className="text-xl font-bold" style={{color: '#D62828'}}>
                    ₹{currentVariant.price.toFixed(0)}
                  </span>
                  <span className="text-sm ml-1" style={{color: '#185E20'}}>
                    / {currentVariant.size}
                  </span>
                </div>
                
                {/* Conditional rendering: Show quantity controls if item is in cart, otherwise show Add to Cart button */}
                {quantityInCart > 0 ? (
                  <div className="flex items-center bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        updateQuantity(cartItemId, quantityInCart - 1, minQuantity);
                      }}
                      disabled={quantityInCart <= minQuantity}
                      className={`w-8 h-8 flex items-center justify-center rounded-l-lg transition-colors duration-200 font-bold text-lg ${
                        quantityInCart <= minQuantity 
                          ? 'text-gray-300 cursor-not-allowed' 
                          : 'text-gray-600 hover:text-red-600 hover:bg-red-50'
                      }`}
                    >
                      −
                    </button>
                    <span className="px-3 py-1 min-w-10 text-center font-semibold text-gray-800 bg-white border-x border-gray-200">
                      {quantityInCart}
                    </span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        updateQuantity(cartItemId, quantityInCart + 1, minQuantity);
                      }}
                      className="w-8 h-8 flex items-center justify-center hover:bg-green-50 rounded-r-lg transition-colors duration-200 font-bold text-lg"
                      style={{color: '#185E20'}}
                    >
                      +
                    </button>
                  </div>
                ) : (
                  <button 
                    onClick={handleAddToCart}
                    disabled={isAdding}
                    className={`font-semibold py-2.5 px-5 rounded-lg text-sm transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95 text-white ${
                      isAdding 
                        ? 'cursor-not-allowed opacity-75'
                        : 'hover:opacity-90'
                    }`}
                    style={{backgroundColor: isAdding ? '#185E20' : '#D62828'}}
                  >
                    {isAdding ? '✓ Added!' : `Add ${minQuantity > 1 ? `${minQuantity} ` : ''}to Cart`}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const Products = () => {
  const [selectedCategory, setSelectedCategory] = React.useState('All');

  const categories = ['All', ...new Set(productsData.map(p => p.category))];

  const filteredProducts = selectedCategory === 'All'
    ? productsData
    : productsData.filter(product => product.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-orange-50">
      <div className="container mx-auto px-4 py-8">
        {/* Page heading with improved styling */}
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-3" style={{color: '#D62828'}}>Our Products</h1>
          <div className="w-24 h-1 mx-auto mb-4 rounded-full" style={{background: 'linear-gradient(to right, #D62828, #185E20)'}}></div>
          <p className="text-lg max-w-2xl mx-auto" style={{color: '#185E20'}}>
            Authentic traditional foods made with love and time-honored recipes
          </p>
        </div>

        {/* Category filter buttons with improved mobile styling */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`py-3 px-6 rounded-full font-semibold transition-all duration-300 text-sm shadow-sm hover:shadow-md transform hover:scale-105 relative ${
                selectedCategory === category
                  ? 'text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
              }`}
              style={selectedCategory === category ? {backgroundColor: '#185E20'} : {}}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Products grid with improved responsive design */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* No products message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">🔍</div>
            <p className="text-gray-500 text-xl mb-2">No products found</p>
            <p className="text-gray-400">Try selecting a different category</p>
          </div>
        )}
      </div>
    </div>
  );
};

// Export the cart context and provider for use in other components
export { CartContext, useCart };